import { defineMessages } from 'react-intl'

const messages = defineMessages({
  ageError: {
    id: 'pax.select-age',
  },
})

export default messages
